
import { Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import {DetailsTicket, Ticketing, DealsList , CustomCalender, CalendarDay, Leads, LeadData, DealsModel, Dashboard, Preview } from "./views/pages";
import routes from "./core/routes";
import { useEffect } from "react";
import Cookies from "js-cookie";
import { AppConstants } from "./core/constants";
import { initDevAuth } from "./core/devAuth";
import { ticketData } from "./Redux/services/ticketService";
import service from "./core/service";
import { useDispatch } from "react-redux";
import { userData } from "./Redux/services/generalService";
import Stage from "./views/pages/stage";

function App() {
  const dispatch = useDispatch();
  const getTicketsList = async () => {
    // let parameters = {
    //   page:  "1",
    //   count:"3",
    // }
    // let url = new URL(`${AppConstants.base_url_api}tickets`)
    // for (const [key, value] of Object.entries(parameters)) {
    //   if (value) {
    //     url.searchParams.append(key, value)
    //   }
    // }
    // try {
    //   setInterval(async () => {
      const response = await service.Notification.list();
      if (response) {
        if (response && response.status === 404) {
        } else {
          dispatch(ticketData(response?.data?.data?.list));
        }
      } else {
      }
    // }, 120000);
    // } catch (error) {
    //   // throw error;
    // }
  };
  const getProfile = async () => {
    try {
      const response = await service.User.profile();
      if (response) {
        if (response && response.status === 404) {
        } else {
          dispatch(userData(response?.data?.data));
        }
      }
    } catch (error: any) {
      if (error && error.status) {
        // navigation(`/profile-not-found`);
      }
    }
  };
  useEffect(() => {
    initDevAuth();
    getTicketsList();
    getProfile();
    Cookies.set('domain', "crm", AppConstants.getCookieOptions())
   
}, []);
  return (
    <Routes>
      <Route path={routes.PREVIEW} element={<Preview />} />
      <Route path={routes.DASHBOARD} element={<Dashboard />} />
      <Route path={routes.TICKETING} element={<Ticketing />} />
      <Route path={routes.DETAILSTICKET} element={<DetailsTicket />} />
      <Route path={routes.LEADSLIST} element={<Leads />} />
      <Route path={routes.LEADDATA} element={<LeadData />} />
      <Route path={routes.DEALMODEL} element={<DealsModel />} />
      <Route path={routes.DEALS} element={<DealsList />} />
      <Route path={routes.STAGE} element={<Stage />} />
      <Route path={routes.CALENDEER} element={<CustomCalender />} />
      <Route path={routes.CALENDARDAY} element={<CalendarDay />} />

    </Routes>
  );
}

export default App;


